import { resolve } from 'path'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getCookieDomain } from '@/utils'
import * as authApis from '@/service/app/auth'
// #ifdef H5
import Cookies from 'js-cookie'
// #endif

const initState = {}
function getSensors() {
  try {
    const app = getApp()
    return app?.globalData?.sensors as any
  } catch (e) {
    console.warn('Failed to get SensorsData SDK:', e)
    return undefined
  }
}
export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref<IUserInfo>({ ...initState })
    const verifyInfo = ref<any>(null)
    const setVerifyInfo = (val: any) => {
      verifyInfo.value = val
    }

    const updateVerifyInfo = async () => {
      const res: any = await authApis.getUmcVerify()
      if (res.data.umc_customer_verify?.status === 1) {
        setVerifyInfo(res.data.umc_customer_verify)
      } else if (res.data.umc_real_enterprise?.status === 1) {
        setVerifyInfo(res.data.umc_real_enterprise)
      } else if (res.data.umc_customer_verify?.status === 0) {
        setVerifyInfo(res.data.umc_customer_verify)
      } else if (res.data.umc_real_enterprise?.status === 0) {
        setVerifyInfo(res.data.umc_real_enterprise)
      } else if (res.data.umc_customer_verify) {
        setVerifyInfo(res.data.umc_customer_verify)
      } else if (res.data.umc_real_enterprise) {
        setVerifyInfo(res.data.umc_real_enterprise)
      } else {
        setVerifyInfo(null)
      }
      return verifyInfo.value
    }

    // const sensors = getApp().globalData.sensors
    const setUserInfo = (val: IUserInfo) => {
      userInfo.value = val

      // if (val.user_id) sensors.login(val.user_id)
      if (val.uid) {
        getSensors()?.login?.(val.uid)
      }
    }

    const token = ref('')
    const setToken = (val: string) => {
      token.value = val
    }

    const clearUserInfo = async () => {
      userInfo.value = { ...initState }
      token.value = ''
      // #ifdef H5
      Cookies.remove('ssoInfo', {
        domain: getCookieDomain(),
        path: '/',
      })
      // #endif
      await new Promise((resolve) => setTimeout(resolve, 500))
      // uni.clearStorage()
      // sensors.logout()
      getSensors()?.logout?.()
    }

    const isLogin = computed(() => !!token.value)

    const loginModalVisible = ref(false)

    return {
      userInfo,
      setUserInfo,
      clearUserInfo,
      isLogin,
      token,
      setToken,
      loginModalVisible,
      verifyInfo,
      setVerifyInfo,
      updateVerifyInfo,
    }
  },
  {
    persist: true,
  },
)
